import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { smoothAfterEnter, smoothEnter, smoothLeave } from "@utils/Routing";
export default {
  data() {
    return {
      selectedProgram: 0,
      transitionName: "slide-left"
    };
  },
  computed: {
    programs() {
      return this.$store.state.programs;
    },
    programOptions() {
      return this.programs.map(p => ({
        value: p.ProgramId,
        text: p.ProgramDescription
      }));
    }
  },
  watch: {
    $route(to, from) {
      let toParts = to.path + "";
      if (toParts.startsWith("/")) {
        toParts = toParts.substr(1, toParts.length - 1);
        toParts = toParts.split("/");
      }
      let fromParts = from.path + "";
      if (fromParts.startsWith("/")) {
        fromParts = fromParts.substr(1, fromParts.length - 1);
        fromParts = fromParts.split("/");
      }
      this.transitionName = toParts.length < fromParts.length ? "slide-right" : "slide-left";
    },
    selectedProgram(newValue) {
      if (this.$route.name === "stateSummary") {
        this.$router.push({
          name: "statePerformance",
          query: {
            programId: newValue
          }
        });
      } else {
        this.$router.push({
          query: {
            programId: newValue
          }
        });
      }
    }
  },
  methods: {
    leave: smoothLeave,
    enter: smoothEnter,
    afterEnter: smoothAfterEnter,
    enterCancelled: smoothAfterEnter
  }
};